class RTKUtils {
  /**
   * Builds the array needed to invalidate the cache via Tags for Orders and Trips tags
   * based on the route
   * Example: Being at /orders,  invalidates the cache for Orders only
   * @param route
   * @returns Array of tags to invalidate [ { type: 'Orders', id: 'ORDERS_LIST' }]
   */
  static invalidateTagsForOrdersAndTrips(route: string): Record<string, string>[] {
    if (route.includes('orders')) {
      return [{ type: 'Orders', id: 'ORDERS_LIST' }];
    }
    if (route.includes('trips/table') || route.includes('trips/calendar')) {
      return [{ type: 'Trips', id: 'TRIPS_LIST' }];
    }
    // board view or driver view
    if (route.includes('trips/board') || route.endsWith('trips')) {
      return [{ type: 'ActiveTrips', id: 'TRIPS_LIST' }];
    }
    return [];
  }
}

export default RTKUtils;
